// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"b9f5971b","390":"76cc8e71","417":"9569b114","558":"272faf5d"}[chunkId] + ".chunk.css";
};